import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@xref/xref-lib';
import { OnboardingTutorialModalComponent } from './onboarding-tutorial-modal.component';

@NgModule({
  declarations: [OnboardingTutorialModalComponent],
  imports: [CommonModule, ButtonModule],
  exports: [OnboardingTutorialModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OnboardingTutorialModalModule {}
